"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9622],{

/***/ 1001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "O0": function() { return /* reexport */ hooks_useCardanData; },
  "Cv": function() { return /* reexport */ hooks_useChatUserData; },
  "YP": function() { return /* reexport */ hooks_useLastViewingProducts; },
  "MW": function() { return /* reexport */ hooks_useProductInfo; },
  "zq": function() { return /* reexport */ hooks_useQuestionInputValidation; },
  "tk": function() { return /* reexport */ hooks_useReviewInputValidation; },
  "v$": function() { return /* reexport */ useUserData/* default */.Z; }
});

// UNUSED EXPORTS: parseEcommerceProductId, useDidUpdateEffect, useSelectedServices, useServicesSelectedOffer, useValidationCookie

// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/typeof.js
var esm_typeof = __webpack_require__(86522);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(56666);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(34795);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 1 modules
var slicedToArray = __webpack_require__(95602);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../publisher/build/esm/index.js + 4 modules
var esm = __webpack_require__(87333);
// EXTERNAL MODULE: ../utils/build/esm/index.js + 122 modules
var build_esm = __webpack_require__(62624);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/constants.js
var ACTIONS = Object.freeze({
  CHANGE_BRAND: 'CHANGE_BRAND',
  CHANGE_MODEL: 'CHANGE_MODEL',
  CHANGE_VERSION: 'CHANGE_VERSION',
  CHANGE_YEAR: 'CHANGE_YEAR',
  FETCH_START: 'FETCH_START',
  RELOAD_PAGE_START: 'RELOAD_PAGE_START',
  RESET_ALL: 'RESET_ALL',
  SAVE_SEARCH_URL: 'SAVE_SEARCH_URL',
  SET_CAR_PLATE: 'SET_CAR_PLATE',
  SET_COMPATIBILITY: 'SET_COMPATIBILITY',
  SET_DATA: 'SET_DATA',
  SET_ERROR: 'SET_ERROR',
  SET_LOADING: 'SET_LOADING',
  SET_PLATE_ERROR: 'SET_PLATE_ERROR',
  SET_SHOW_SUMMARY: 'SET_SHOW_SUMMARY',
  SET_VEHICLE_DETAILS: 'SET_VEHICLE_DETAILS'
});
var ENTITIES = Object.freeze({
  BRANDS: 'brands',
  MODELS: 'models',
  VERSIONS: 'versions',
  YEARS: 'years'
});
var EVENTS = Object.freeze({
  HANDLE_FORM_FIELDCHANGE: 'cardan:handle:formfieldchange',
  HANDLE_FORM_RESET: 'cardan:handle:formreset',
  HANDLE_FORM_SEARCH: 'cardan:handle:formsearch',
  HANDLE_SHOW_SUMMARY: 'cardan:handle:summary'
});
var VEHICLE_ITEMS = Object.freeze(['brand', 'model', 'version', 'year']);
var VEHICLE_SEARCH_FILTERS = VEHICLE_ITEMS.map(function (item) {
  return "car_".concat(item);
});
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(7896);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/utils/index.js
var calcFormatSingleItem = function calcFormatSingleItem(item, nameProperty, extraProps) {
  var id = String((item == null ? void 0 : item.id) || '');
  var result = {
    id: id,
    name: String((item == null ? void 0 : item[nameProperty]) || ''),
    value: String((item == null ? void 0 : item[nameProperty]) || '')
  };
  if (Array.isArray(extraProps)) {
    extraProps.forEach(function (prop) {
      if (prop && (item == null ? void 0 : item[prop]) !== undefined) {
        result[prop] = item[prop];
      }
    });
  }
  return result;
};
var createUrlDataObject = function createUrlDataObject(path, search) {
  var searchParams = new URLSearchParams(search);
  var existingFilters = searchParams.get('filters') ? searchParams.get('filters').split('+') : [];
  return {
    existingFilters: existingFilters,
    path: path,
    searchParams: searchParams
  };
};
var formatData = function formatData(items) {
  var nameProperty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'name';
  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var onError = arguments.length > 3 ? arguments[3] : undefined;
  if (!Array.isArray(items)) {
    return [];
  }
  try {
    return items.map(function (item) {
      return calcFormatSingleItem(item, nameProperty, extraProps);
    });
  } catch (error) {
    onError(error);
    return [];
  }
};
var parseUrl = function parseUrl(urlString, location) {
  if (urlString.match(/^https?:\/\//)) {
    return new URL(urlString);
  }
  if (urlString.startsWith('//')) {
    return new URL("http:".concat(urlString));
  }
  var origin = (location == null ? void 0 : location.origin) || "".concat(location == null ? void 0 : location.protocol, "//").concat(location == null ? void 0 : location.host);
  var fullUrl = urlString.startsWith('/') ? "".concat(origin).concat(urlString) : "".concat(origin, "/").concat(urlString);
  return new URL(fullUrl);
};
var slugfyUrl = function slugfyUrl(input) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '-';
  if (typeof input !== 'string') {
    return '';
  }
  var escapedSeparator = separator.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return input.toString().normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^\w-]/g, separator).replace(new RegExp("".concat(escapedSeparator, "{2,}"), 'g'), separator).replace(new RegExp("^".concat(escapedSeparator, "+|").concat(escapedSeparator, "+$"), 'g'), '');
};
// EXTERNAL MODULE: ../graphql/build/esm/index.js
var graphql_build_esm = __webpack_require__(76613);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/services/cardanDataService.js



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }



var cardanDataService = function cardanDataService(state, dispatch) {
  var _useCardan = (0,graphql_build_esm.useCardan)(),
    fetchCompatibilityDataHook = _useCardan.fetchCompatibilityDataHook,
    fetchVehicleDataHook = _useCardan.fetchVehicleDataHook,
    fetchPlateDataHook = _useCardan.fetchPlateDataHook;
  var processResponseData = function processResponseData(data) {
    var dataProcessors = [{
      entity: ENTITIES.BRANDS,
      format: function format(items) {
        return formatData(items, 'name', ['urlLogo']);
      },
      key: 'vehicleBrands'
    }, {
      entity: ENTITIES.MODELS,
      format: function format(items) {
        return formatData(items);
      },
      key: 'vehicleModels'
    }, {
      entity: ENTITIES.YEARS,
      format: function format(items) {
        return formatData(items, 'year');
      },
      key: 'vehicleYears'
    }, {
      entity: ENTITIES.VERSIONS,
      format: function format(items) {
        return formatData(items);
      },
      key: 'vehicleVersions'
    }];
    dataProcessors.forEach(function (_ref) {
      var key = _ref.key,
        entity = _ref.entity,
        format = _ref.format;
      if (data[key]) {
        var formattedData = format(data[key]);
        dispatch({
          entity: entity,
          payload: formattedData,
          type: ACTIONS.SET_DATA
        });
      }
    });
  };
  var processPlateData = function processPlateData(data) {
    var _state$data, _global, _global$window, _global$window$locati;
    dispatch({
      payload: data.plate,
      type: ACTIONS.SET_CAR_PLATE
    });
    var brands = state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data[ENTITIES.BRANDS];
    var selectedBrandObj = brands.find(function (brand) {
      return String(brand == null ? void 0 : brand.name) === String(data.brand);
    });
    dispatch({
      payload: {
        id: data.brand,
        urlLogo: selectedBrandObj == null ? void 0 : selectedBrandObj.urlLogo
      },
      type: ACTIONS.CHANGE_BRAND
    });
    dispatch({
      payload: String(data.model),
      type: ACTIONS.CHANGE_MODEL
    });
    dispatch({
      payload: String(data.year),
      type: ACTIONS.CHANGE_YEAR
    });
    dispatch({
      payload: String(data.version),
      type: ACTIONS.CHANGE_VERSION
    });
    var vehicleDetails = "".concat(data.brand, " ").concat(data.model, " ").concat(data.year, " ").concat(data.version);
    dispatch({
      payload: vehicleDetails,
      type: ACTIONS.SET_VEHICLE_DETAILS
    });
    dispatch({
      payload: (_global = __webpack_require__.g) == null ? void 0 : (_global$window = _global.window) == null ? void 0 : (_global$window$locati = _global$window.location) == null ? void 0 : _global$window$locati.pathname,
      type: ACTIONS.SAVE_SEARCH_URL
    });
  };
  var fetchCompatibilityDataService = function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee(partnumber) {
      var _data$compatibility, compatibilityParams, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              type: ACTIONS.FETCH_START
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            _context.prev = 2;
            compatibilityParams = (0,esm_extends/* default */.Z)({}, state.selected || {}, {
              partNumber: String(partnumber || '')
            });
            _context.next = 6;
            return fetchCompatibilityDataHook(compatibilityParams);
          case 6:
            data = _context.sent;
            if (data) {
              _context.next = 9;
              break;
            }
            return _context.abrupt("return", null);
          case 9:
            dispatch({
              payload: data == null ? void 0 : (_data$compatibility = data.compatibility) == null ? void 0 : _data$compatibility.compatible,
              type: ACTIONS.SET_COMPATIBILITY
            });
            return _context.abrupt("return", data);
          case 13:
            _context.prev = 13;
            _context.t0 = _context["catch"](2);
            dispatch({
              payload: _context.t0.message || 'Unknown error occurred',
              type: ACTIONS.SET_ERROR
            });
            return _context.abrupt("return", null);
          case 17:
            _context.prev = 17;
            dispatch({
              type: ACTIONS.FETCH_END
            });
            return _context.finish(17);
          case 20:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 13, 17, 20]]);
    }));
    return function fetchCompatibilityDataService(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var fetchVehicleDataService = function () {
    var _ref3 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee2() {
      var data;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            dispatch({
              type: ACTIONS.FETCH_START
            });
            dispatch({
              payload: true,
              type: ACTIONS.SET_LOADING
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            _context2.prev = 3;
            _context2.next = 6;
            return fetchVehicleDataHook(state.selected);
          case 6:
            data = _context2.sent;
            if (data) {
              _context2.next = 9;
              break;
            }
            return _context2.abrupt("return", null);
          case 9:
            processResponseData(data);
            return _context2.abrupt("return", data);
          case 13:
            _context2.prev = 13;
            _context2.t0 = _context2["catch"](3);
            dispatch({
              payload: _context2.t0.message || 'Unknown error occurred',
              type: ACTIONS.SET_ERROR
            });
            return _context2.abrupt("return", null);
          case 17:
            _context2.prev = 17;
            dispatch({
              type: ACTIONS.FETCH_END
            });
            dispatch({
              payload: false,
              type: ACTIONS.SET_LOADING
            });
            return _context2.finish(17);
          case 21:
          case "end":
            return _context2.stop();
        }
      }, _callee2, null, [[3, 13, 17, 21]]);
    }));
    return function fetchVehicleDataService() {
      return _ref3.apply(this, arguments);
    };
  }();
  var fetchPlateDataService = function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)(_regeneratorRuntime().mark(function _callee3(plateStr) {
      var plateData, data;
      return _regeneratorRuntime().wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            dispatch({
              payload: null,
              type: ACTIONS.SET_ERROR
            });
            dispatch({
              payload: null,
              type: ACTIONS.SET_PLATE_ERROR
            });
            _context3.prev = 2;
            _context3.next = 5;
            return fetchPlateDataHook(plateStr);
          case 5:
            plateData = _context3.sent;
            if (plateData) {
              _context3.next = 8;
              break;
            }
            throw new Error('Placa não encontrada');
          case 8:
            processPlateData(plateData);
            _context3.next = 11;
            return fetchVehicleDataHook(plateData);
          case 11:
            data = _context3.sent;
            if (data) {
              _context3.next = 14;
              break;
            }
            throw new Error('Tipo do veículo não encontrado');
          case 14:
            processResponseData(data);
            dispatch({
              payload: true,
              type: ACTIONS.SET_SHOW_SUMMARY
            });
            return _context3.abrupt("return", plateData);
          case 19:
            _context3.prev = 19;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", dispatch({
              payload: _context3.t0.message || 'Não foi possível pesquisar esta placa',
              type: ACTIONS.SET_PLATE_ERROR
            }));
          case 22:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[2, 19]]);
    }));
    return function fetchPlateDataService(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  return {
    fetchCompatibilityDataService: fetchCompatibilityDataService,
    fetchPlateDataService: fetchPlateDataService,
    fetchVehicleDataService: fetchVehicleDataService,
    processPlateData: processPlateData,
    processResponseData: processResponseData
  };
};
/* harmony default export */ var services_cardanDataService = (cardanDataService);
// EXTERNAL MODULE: ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js + 2 modules
var toConsumableArray = __webpack_require__(85942);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/helpers/cardanDataHelpers.js






var buildCurrentUrlData = function buildCurrentUrlData(customUrl) {
  var _global, _global$window;
  var location = (_global = __webpack_require__.g) == null ? void 0 : (_global$window = _global.window) == null ? void 0 : _global$window.location;
  if (!customUrl) {
    var path = location == null ? void 0 : location.pathname;
    var search = location == null ? void 0 : location.search;
    return createUrlDataObject(path, search);
  }
  try {
    var url = parseUrl(customUrl, location);
    return createUrlDataObject(url.pathname, url.search);
  } catch (error) {
    var _path = customUrl.split('?')[0];
    var _search = customUrl.includes('?') ? "".concat(customUrl.split('?')[1]) : '';
    return createUrlDataObject(_path, _search);
  }
};
var buildRemainingFilters = function buildRemainingFilters(existingFilters, vehicleFilterTypes) {
  return existingFilters.filter(function (filter) {
    var filterType = filter.split('---')[0];
    return !vehicleFilterTypes.includes(filterType);
  });
};
var buildSearchParams = function buildSearchParams(searchParams) {
  var newSearchParams = new URLSearchParams();
  searchParams.forEach(function (value, key) {
    if (key !== 'filters') newSearchParams.set(key, value);
  });
  return newSearchParams;
};
var buildVehicleFilterUrl = function buildVehicleFilterUrl(_ref) {
  var selected = _ref.selected,
    vehicleItems = _ref.vehicleItems,
    currentPath = _ref.path,
    searchParams = _ref.searchParams,
    existingFilters = _ref.existingFilters;
  var createVehicleFilters = function createVehicleFilters() {
    if (!selected) return [];
    return vehicleItems.map(function (item) {
      var value = selected[item];
      if (value === null || value === undefined || value === '') {
        return null;
      }
      return {
        type: "car_".concat(item),
        value: slugfyUrl(value)
      };
    }).filter(function (filter) {
      return filter !== null && filter.value;
    });
  };
  var newSearchParams = buildSearchParams(searchParams);
  var vehicleFilters = createVehicleFilters();
  var validFilters = [];
  var vehicleFilterTypes = [];
  vehicleFilters.forEach(function (filter) {
    validFilters.push("".concat(filter.type, "---").concat(filter.value));
    vehicleFilterTypes.push(filter.type);
  });
  var remainingFilters = buildRemainingFilters(existingFilters, vehicleFilterTypes);
  var finalFilters = [].concat((0,toConsumableArray/* default */.Z)(remainingFilters), validFilters);
  if (finalFilters.length > 0) {
    newSearchParams.set('filters', finalFilters.join('+'));
  }
  var queryString = newSearchParams.toString();
  return "".concat(currentPath).concat(queryString ? "?".concat(queryString) : '');
};
var calcVerticalMarginHelper = function calcVerticalMarginHelper(withSpace) {
  var DEFAULT_MARGIN = '8px';
  if (!withSpace || typeof document === 'undefined') {
    return DEFAULT_MARGIN;
  }
  try {
    var breadcrumb = document.querySelector("[data-testid='breadcrumb-container']");
    var searchFilters = document.querySelector("[data-testid='search-filters']");
    if (!breadcrumb || !searchFilters) {
      return DEFAULT_MARGIN;
    }
    var breadcrumbRect = breadcrumb.getBoundingClientRect();
    var searchFiltersRect = searchFilters.getBoundingClientRect();
    if (!breadcrumbRect || !searchFiltersRect || typeof breadcrumbRect.height !== 'number' || typeof breadcrumbRect.top !== 'number' || typeof searchFiltersRect.top !== 'number') {
      return DEFAULT_MARGIN;
    }
    var marginBetween = Math.abs(searchFiltersRect.top - (breadcrumbRect.height + breadcrumbRect.top));
    return "".concat(marginBetween, "px");
  } catch (error) {
    console.error('Error calculating margin:', error);
    return DEFAULT_MARGIN;
  }
};
var createSaveToCookie = function createSaveToCookie(cookieDomain) {
  return function () {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var expiryDate = new Date();
    expiryDate.setMonth(expiryDate.getMonth() + 1);
    (0,build_esm/* setCookie */.d8)({
      domain: cookieDomain,
      expires: expiryDate,
      name: build_esm/* cookiesConstants.CARDAN_TRACK_MENU */.VD.CARDAN_TRACK_MENU,
      path: '/',
      value: JSON.stringify(data)
    });
  };
};
var extractFiltersFromUrl = function extractFiltersFromUrl(filtersArray) {
  var filtersMap = {};
  filtersArray.forEach(function (filter) {
    var parts = filter.split('---');
    if (parts.length === 2) {
      var _parts = (0,slicedToArray/* default */.Z)(parts, 2),
        type = _parts[0],
        value = _parts[1];
      filtersMap[type] = value;
    }
  });
  return filtersMap;
};
var getEmptyData = function getEmptyData() {
  return {
    brands: [],
    models: [],
    versions: [],
    years: []
  };
};
var getEmptySelection = function getEmptySelection() {
  return {
    brand: null,
    brandLogo: null,
    carPlate: null,
    model: null,
    searchUrl: null,
    vehicleDetails: null,
    version: null,
    year: null
  };
};
var getFromCookie = function getFromCookie() {
  try {
    return (0,build_esm/* getCookie */.ej)(build_esm/* cookiesConstants.CARDAN_TRACK_MENU */.VD.CARDAN_TRACK_MENU);
  } catch (err) {
    console.error('Error reading from cookies:', err);
    return null;
  }
};
var parseSavedData = function parseSavedData(data) {
  if (!data) return {};
  if ((0,esm_typeof/* default */.Z)(data) === 'object') {
    return data;
  }
  if (typeof data === 'string') {
    try {
      return JSON.parse(data);
    } catch (error) {
      try {
        return JSON.parse(decodeURIComponent(data));
      } catch (parseError) {
        return {};
      }
    }
  }
  return {};
};
var inferVersionFromSummaryDescription = function inferVersionFromSummaryDescription(summaryDescription, year) {
  if (typeof summaryDescription !== 'string') return null;
  var normalizedSummary = summaryDescription.replace(/\s+/g, ' ').trim();
  if (!normalizedSummary || !year) return null;
  var yearStr = String(year);
  var indexOfYear = normalizedSummary.indexOf(yearStr);
  if (indexOfYear < 0) return null;
  return normalizedSummary.slice(indexOfYear + yearStr.length).replace(/^[-:|/,\s]+/, '').trim() || null;
};
var getSavedState = function getSavedState() {
  var _savedData$uiState, _savedData$uiState2;
  var rawSavedData = getFromCookie();
  var savedData = parseSavedData(rawSavedData);
  var savedShowSummary = savedData == null ? void 0 : (_savedData$uiState = savedData.uiState) == null ? void 0 : _savedData$uiState.showSummary;
  var savedSummaryDescription = savedData == null ? void 0 : (_savedData$uiState2 = savedData.uiState) == null ? void 0 : _savedData$uiState2.summaryDescription;
  var selected = (savedData == null ? void 0 : savedData.selected) || getEmptySelection();
  if (!(selected == null ? void 0 : selected.vehicleDetails) && typeof savedSummaryDescription === 'string') {
    var normalizedSummaryDescription = savedSummaryDescription.replace(/\s+/g, ' ').trim();
    if (normalizedSummaryDescription) {
      selected.vehicleDetails = normalizedSummaryDescription;
    }
  }
  if (!(selected == null ? void 0 : selected.version) && savedSummaryDescription) {
    var inferredVersion = inferVersionFromSummaryDescription(savedSummaryDescription, selected == null ? void 0 : selected.year);
    if (inferredVersion) {
      selected.version = inferredVersion;
    }
  }
  return {
    selected: selected,
    uiState: {
      showSummary: typeof savedShowSummary === 'boolean' ? savedShowSummary : false
    }
  };
};
var isVehicleFilter = function isVehicleFilter(filter) {
  var filterType = filter.split('---')[0];
  return VEHICLE_SEARCH_FILTERS.includes(filterType) || filterType.startsWith('car_');
};
var hasCleanUrlWithoutCardanFilters = function hasCleanUrlWithoutCardanFilters(existingFilters) {
  try {
    if (!existingFilters || existingFilters.length === 0) {
      return true;
    }
    var hasCardanFilter = existingFilters.some(isVehicleFilter);
    return !hasCardanFilter;
  } catch (error) {
    return true;
  }
};
var hasMatchingUrlFilters = function hasMatchingUrlFilters(selected, existingFilters) {
  if (!selected) return false;
  try {
    var currentFiltersMap = extractFiltersFromUrl(existingFilters);
    var filterMapping = VEHICLE_ITEMS.reduce(function (acc, item) {
      acc[item] = "car_".concat(item);
      return acc;
    }, {});
    return Object.entries(filterMapping).every(function (_ref2) {
      var _ref3 = (0,slicedToArray/* default */.Z)(_ref2, 2),
        stateKey = _ref3[0],
        filterKey = _ref3[1];
      var selectedValue = selected[stateKey];
      if (!selectedValue) return false;
      var urlValue = currentFiltersMap[filterKey];
      return urlValue === slugfyUrl(selectedValue);
    });
  } catch (error) {
    return false;
  }
};
var cardanDataHelpers_removeVehicleFilters = function removeVehicleFilters(urlData) {
  var _ref4 = urlData || {},
    currentPath = _ref4.path,
    searchParams = _ref4.searchParams,
    existingFilters = _ref4.existingFilters;
  if (!currentPath) {
    return '';
  }
  var newSearchParams = buildSearchParams(searchParams || new URLSearchParams());
  var remainingFilters = (existingFilters || []).filter(function (filter) {
    return !isVehicleFilter(filter);
  });
  if (remainingFilters.length > 0) {
    newSearchParams.set('filters', remainingFilters.join('+'));
  }
  var queryString = newSearchParams.toString();
  return "".concat(currentPath).concat(queryString ? "?".concat(queryString) : '');
};
var scrollToAnchorQuestionButton = function scrollToAnchorQuestionButton() {
  var anchorElement = document.getElementById('question-list-anchor');
  if (anchorElement && (anchorElement == null ? void 0 : anchorElement.scrollIntoView)) {
    anchorElement.scrollIntoView({
      behavior: 'smooth',
      block: 'center'
    });
  }
};
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/events/cardanDataEvents.js



var CardanDataEvents = function CardanDataEvents(state, dispatch) {
  var handleBrandChange = function handleBrandChange(value) {
    var _state$data;
    var brandEntity = ENTITIES.BRANDS;
    var brands = state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data[brandEntity];
    var selectedBrandObj = brands == null ? void 0 : brands.find(function (brand) {
      return String(brand == null ? void 0 : brand.name) === String(value);
    });
    dispatch({
      payload: {
        id: value,
        urlLogo: (selectedBrandObj == null ? void 0 : selectedBrandObj.urlLogo) || null
      },
      type: ACTIONS.CHANGE_BRAND
    });
  };
  var handleFormFieldChange = function handleFormFieldChange(field, value) {
    switch (field) {
      case 'brand':
        handleBrandChange(value);
        break;
      case 'model':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_MODEL
        });
        break;
      case 'year':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_YEAR
        });
        break;
      case 'version':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_VERSION
        });
        break;
      default:
        break;
    }
  };
  var handleFormReset = function handleFormReset() {
    dispatch({
      type: ACTIONS.RESET_ALL
    });
  };
  var handleFormSearch = function handleFormSearch() {
    var _state$selected;
    if (!((_state$selected = state.selected) == null ? void 0 : _state$selected.version)) {
      return;
    }
    var currentUrl = buildVehicleFilterUrl((0,esm_extends/* default */.Z)({
      selected: state.selected,
      vehicleItems: VEHICLE_ITEMS
    }, buildCurrentUrlData()));
    var vehicleDetails = "".concat(state.selected.brand, " ").concat(state.selected.model, " ").concat(state.selected.year, " ").concat(state.selected.version);
    dispatch({
      payload: vehicleDetails,
      type: ACTIONS.SET_VEHICLE_DETAILS
    });
    dispatch({
      payload: currentUrl,
      type: ACTIONS.SAVE_SEARCH_URL
    });
    dispatch({
      payload: true,
      type: ACTIONS.SET_SHOW_SUMMARY
    });
  };
  var handleShowSummary = function handleShowSummary(value) {
    dispatch({
      payload: value,
      type: ACTIONS.SET_SHOW_SUMMARY
    });
  };
  return {
    handleFormFieldChange: handleFormFieldChange,
    handleFormReset: handleFormReset,
    handleFormSearch: handleFormSearch,
    handleShowSummary: handleShowSummary
  };
};
/* harmony default export */ var cardanDataEvents = (CardanDataEvents);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/reducers/useCardanDataReducer.js




var createInitialState = function createInitialState() {
  var savedState = getSavedState();
  return {
    compatibility: null,
    data: getEmptyData(),
    error: null,
    loading: false,
    pendingFetch: false,
    pendingReloadPage: false,
    plateError: null,
    selected: (0,esm_extends/* default */.Z)({}, getEmptySelection(), savedState == null ? void 0 : savedState.selected),
    uiState: (0,esm_extends/* default */.Z)({
      showSummary: false
    }, savedState == null ? void 0 : savedState.uiState)
  };
};
var useCardanDataReducer = function useCardanDataReducer() {
  var handleChangeBrand = function handleChangeBrand(state, action) {
    var _action$payload = action == null ? void 0 : action.payload,
      id = _action$payload.id,
      urlLogo = _action$payload.urlLogo;
    return (0,esm_extends/* default */.Z)({}, state, {
      data: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.data, {
        models: [],
        versions: [],
        years: []
      }),
      pendingFetch: true,
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        brand: id,
        brandLogo: urlLogo || null,
        model: null,
        version: null,
        year: null
      })
    });
  };
  var handleChangeModel = function handleChangeModel(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      data: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.data, {
        versions: [],
        years: []
      }),
      pendingFetch: true,
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        model: action == null ? void 0 : action.payload,
        version: null,
        year: null
      })
    });
  };
  var handleChangeVersion = function handleChangeVersion(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        version: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeYear = function handleChangeYear(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      data: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.data, {
        versions: []
      }),
      pendingFetch: true,
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        version: null,
        year: action == null ? void 0 : action.payload
      })
    });
  };
  var handleResetAll = function handleResetAll(state) {
    var _state$selected;
    var currentUrl = cardanDataHelpers_removeVehicleFilters(buildCurrentUrlData(state == null ? void 0 : (_state$selected = state.selected) == null ? void 0 : _state$selected.searchUrl));
    return (0,esm_extends/* default */.Z)({}, state, {
      data: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.data, {
        models: [],
        versions: [],
        years: []
      }),
      pendingFetch: true,
      pendingReloadPage: true,
      selected: (0,esm_extends/* default */.Z)({}, getEmptySelection(), {
        searchUrl: currentUrl
      }),
      uiState: {
        showSummary: false
      }
    });
  };
  var handleSaveSearchUrl = function handleSaveSearchUrl(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      pendingFetch: false,
      pendingReloadPage: true,
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        searchUrl: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeCarPlate = function handleChangeCarPlate(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        carPlate: action == null ? void 0 : action.payload
      })
    });
  };
  var handleChangeVehicleDetails = function handleChangeVehicleDetails(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      selected: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.selected, {
        vehicleDetails: action == null ? void 0 : action.payload
      })
    });
  };
  var handleSetShowSummary = function handleSetShowSummary(state, action) {
    var updatedUiState = (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.uiState, {
      showSummary: action == null ? void 0 : action.payload
    });
    return (0,esm_extends/* default */.Z)({}, state, {
      uiState: updatedUiState
    });
  };
  var handleChangeCompatibility = function handleChangeCompatibility(state, action) {
    return (0,esm_extends/* default */.Z)({}, state, {
      compatibility: action == null ? void 0 : action.payload,
      pendingFetch: false
    });
  };
  var cardanReducer = function cardanReducer(state, action) {
    if (!(action == null ? void 0 : action.type) && !(action == null ? void 0 : action.payload)) return state;
    switch (action.type) {
      case ACTIONS.CHANGE_BRAND:
        return handleChangeBrand(state, action);
      case ACTIONS.CHANGE_MODEL:
        return handleChangeModel(state, action);
      case ACTIONS.CHANGE_VERSION:
        return handleChangeVersion(state, action);
      case ACTIONS.CHANGE_YEAR:
        return handleChangeYear(state, action);
      case ACTIONS.FETCH_START:
        return (0,esm_extends/* default */.Z)({}, state, {
          pendingFetch: false
        });
      case ACTIONS.RELOAD_PAGE_START:
        return (0,esm_extends/* default */.Z)({}, state, {
          pendingReloadPage: false
        });
      case ACTIONS.RESET_ALL:
        return handleResetAll(state);
      case ACTIONS.SAVE_SEARCH_URL:
        return handleSaveSearchUrl(state, action);
      case ACTIONS.SET_COMPATIBILITY:
        return handleChangeCompatibility(state, action);
      case ACTIONS.SET_DATA:
        return (0,esm_extends/* default */.Z)({}, state, {
          data: (0,esm_extends/* default */.Z)({}, state == null ? void 0 : state.data, (0,defineProperty/* default */.Z)({}, action.entity, action == null ? void 0 : action.payload)),
          pendingFetch: false
        });
      case ACTIONS.SET_ERROR:
        return (0,esm_extends/* default */.Z)({}, state, {
          error: action == null ? void 0 : action.payload,
          pendingFetch: false
        });
      case ACTIONS.SET_LOADING:
        return (0,esm_extends/* default */.Z)({}, state, {
          loading: action == null ? void 0 : action.payload
        });
      case ACTIONS.SET_SHOW_SUMMARY:
        return handleSetShowSummary(state, action);
      case ACTIONS.SET_CAR_PLATE:
        return handleChangeCarPlate(state, action);
      case ACTIONS.SET_PLATE_ERROR:
        return (0,esm_extends/* default */.Z)({}, state, {
          plateError: action == null ? void 0 : action.payload
        });
      case ACTIONS.SET_VEHICLE_DETAILS:
        return handleChangeVehicleDetails(state, action);
      default:
        return state;
    }
  };
  return {
    cardanReducer: cardanReducer,
    createInitialState: createInitialState
  };
};
/* harmony default export */ var reducers_useCardanDataReducer = (useCardanDataReducer);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useCardanData/index.js




function useCardanData_regeneratorRuntime() { "use strict"; useCardanData_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }








var useCardanData = function useCardanData(_ref) {
  var _state$uiState;
  var cookieDomain = _ref.cookieDomain;
  var _useCardanDataReducer = reducers_useCardanDataReducer(),
    cardanReducer = _useCardanDataReducer.cardanReducer,
    createInitialState = _useCardanDataReducer.createInitialState;
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _useReducer = (0,react.useReducer)(cardanReducer, null, createInitialState),
    _useReducer2 = (0,slicedToArray/* default */.Z)(_useReducer, 2),
    state = _useReducer2[0],
    dispatch = _useReducer2[1];
  var _createCardanDataServ = services_cardanDataService(state, dispatch),
    fetchCompatibilityDataService = _createCardanDataServ.fetchCompatibilityDataService,
    fetchVehicleDataService = _createCardanDataServ.fetchVehicleDataService,
    fetchPlateDataService = _createCardanDataServ.fetchPlateDataService;
  var _createCardanDataEven = cardanDataEvents(state, dispatch),
    handleFormFieldChange = _createCardanDataEven.handleFormFieldChange,
    handleFormReset = _createCardanDataEven.handleFormReset,
    handleFormSearch = _createCardanDataEven.handleFormSearch,
    handleShowSummary = _createCardanDataEven.handleShowSummary;
  var fetchCompatibilityData = (0,react.useCallback)(function () {
    var _ref2 = (0,asyncToGenerator/* default */.Z)(useCardanData_regeneratorRuntime().mark(function _callee(partnumber) {
      return useCardanData_regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return fetchCompatibilityDataService(partnumber);
          case 3:
            _context.next = 8;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
            dispatch({
              payload: (_context.t0 == null ? void 0 : _context.t0.message) || 'Erro ao buscar dados de compatibilidade do produto',
              type: ACTIONS.SET_ERROR
            });
          case 8:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [fetchCompatibilityDataService, dispatch]);
  var fetchVehicleData = (0,react.useCallback)((0,asyncToGenerator/* default */.Z)(useCardanData_regeneratorRuntime().mark(function _callee2() {
    return useCardanData_regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.prev = 0;
          _context2.next = 3;
          return fetchVehicleDataService();
        case 3:
          _context2.next = 8;
          break;
        case 5:
          _context2.prev = 5;
          _context2.t0 = _context2["catch"](0);
          dispatch({
            payload: (_context2.t0 == null ? void 0 : _context2.t0.message) || 'Erro ao buscar dados do veículo',
            type: 'SET_ERROR'
          });
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2, null, [[0, 5]]);
  })), [fetchVehicleDataService, dispatch]);
  var vehicleDetails = (0,react.useMemo)(function () {
    var vehicleItems = VEHICLE_ITEMS.map(function (vehicleItem) {
      var _state$selected;
      return (_state$selected = state.selected) == null ? void 0 : _state$selected[vehicleItem];
    });
    if (vehicleItems.every(function (text) {
      return text;
    })) return vehicleItems.join(' ');
    return null;
  }, [state]);
  var saveToCookie = (0,react.useMemo)(function () {
    return createSaveToCookie(cookieDomain);
  }, [cookieDomain]);
  var hasPersistedInitialStateRef = (0,react.useRef)(false);
  (0,react.useEffect)(function () {
    if (!hasPersistedInitialStateRef.current) {
      hasPersistedInitialStateRef.current = true;
      return;
    }
    saveToCookie({
      selected: state == null ? void 0 : state.selected,
      uiState: state == null ? void 0 : state.uiState
    });
  }, [saveToCookie, state == null ? void 0 : state.selected, state == null ? void 0 : state.uiState]);
  (0,react.useEffect)(function () {
    if (state.pendingReloadPage) {
      var _state$selected2;
      dispatch({
        type: ACTIONS.RELOAD_PAGE_START
      });
      (0,build_esm/* routePush */.dY)({
        path: (_state$selected2 = state.selected) == null ? void 0 : _state$selected2.searchUrl,
        spa: true
      });
    }
    if (state.pendingFetch) {
      fetchVehicleData();
    }
  }, [state, fetchVehicleData]);
  (0,react.useEffect)(function () {
    var eventHandlers = (0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)((0,defineProperty/* default */.Z)({}, EVENTS.HANDLE_FORM_SEARCH, handleFormSearch), EVENTS.HANDLE_FORM_RESET, handleFormReset), EVENTS.HANDLE_FORM_FIELDCHANGE, handleFormFieldChange), EVENTS.HANDLE_SHOW_SUMMARY, handleShowSummary);
    Object.entries(eventHandlers).forEach(function (_ref4) {
      var _ref5 = (0,slicedToArray/* default */.Z)(_ref4, 2),
        event = _ref5[0],
        handler = _ref5[1];
      subscribe(event, handler);
    });
    return function () {
      Object.entries(eventHandlers).forEach(function (_ref6) {
        var _ref7 = (0,slicedToArray/* default */.Z)(_ref6, 2),
          event = _ref7[0],
          handler = _ref7[1];
        unsubscribe(event, handler);
      });
    };
  }, [subscribe, unsubscribe, handleFormSearch, handleFormReset, handleShowSummary, handleFormFieldChange]);
  var hasRenderedNoMatchingFilter = (0,react.useRef)(false);
  var synchronizeUrlFilters = function synchronizeUrlFilters(selectedItems) {
    var _state$selected3;
    var searchUrl = (state == null ? void 0 : state.pendingReloadPage) ? state == null ? void 0 : (_state$selected3 = state.selected) == null ? void 0 : _state$selected3.searchUrl : undefined;
    var _buildCurrentUrlData = buildCurrentUrlData(searchUrl),
      existingFilters = _buildCurrentUrlData.existingFilters;
    var hasMatchingFilters = hasMatchingUrlFilters(selectedItems, existingFilters);
    var isUrlClean = hasCleanUrlWithoutCardanFilters(existingFilters);
    if (!isUrlClean && hasMatchingFilters && searchUrl) {
      handleShowSummary(true);
      return;
    }
    if (!hasMatchingFilters) {
      if (!isUrlClean && !hasRenderedNoMatchingFilter.current) {
        (0,build_esm/* routePush */.dY)({
          path: cardanDataHelpers_removeVehicleFilters(buildCurrentUrlData(selectedItems == null ? void 0 : selectedItems.searchUrl)),
          spa: true
        });
      }
      handleShowSummary(false);
      hasRenderedNoMatchingFilter.current = true;
    }
  };
  return {
    calcVerticalMarginHelper: calcVerticalMarginHelper,
    entities: ENTITIES,
    error: state == null ? void 0 : state.error,
    events: EVENTS,
    fetchCompatibilityData: fetchCompatibilityData,
    fetchVehicleData: fetchVehicleData,
    isCompatible: (state == null ? void 0 : state.compatibility) === 's',
    loading: state == null ? void 0 : state.loading,
    plateError: state == null ? void 0 : state.plateError,
    removeVehicleFilters: function removeVehicleFilters(url) {
      return cardanDataHelpers_removeVehicleFilters(buildCurrentUrlData(url));
    },
    scrollToAnchorQuestionButton: scrollToAnchorQuestionButton,
    searchPlate: fetchPlateDataService,
    selectedItems: state == null ? void 0 : state.selected,
    showSummary: state == null ? void 0 : (_state$uiState = state.uiState) == null ? void 0 : _state$uiState.showSummary,
    synchronizeUrlFilters: synchronizeUrlFilters,
    vehicleData: state == null ? void 0 : state.data,
    vehicleDetails: vehicleDetails
  };
};
/* harmony default export */ var hooks_useCardanData = (useCardanData);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useDidUpdateEffect.js
var useDidUpdateEffect = __webpack_require__(13450);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useProductInfo.js





var useProductInfo = function useProductInfo(product) {
  var _bundles$, _ref2;
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _usePublisher = (0,esm/* usePublisher */.Np)(),
    subscribe = _usePublisher.subscribe,
    unsubscribe = _usePublisher.unsubscribe;
  var _ref = product || {},
    bundles = _ref.bundles,
    factsheet = _ref.factsheet,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? '' : _ref$description;
  var _useState = (0,react.useState)((bundles == null ? void 0 : (_bundles$ = bundles[0]) == null ? void 0 : _bundles$.id) || null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    bundleId = _useState2[0],
    setBundleId = _useState2[1];
  var handleBundleClickEvent = function handleBundleClickEvent(id) {
    return setBundleId(id);
  };
  (0,react.useEffect)(function () {
    subscribe('product:bundle:click', handleBundleClickEvent);
    return function () {
      unsubscribe('product:bundle:click', handleBundleClickEvent);
    };
  });
  var productInfo = {};
  var currentBundle = (_ref2 = bundles || []) == null ? void 0 : _ref2.find(function (_ref3) {
    var id = _ref3.id;
    return id === bundleId;
  });
  productInfo.title = (currentBundle == null ? void 0 : currentBundle.title) || title;
  var bundleFactsheet = currentBundle == null ? void 0 : currentBundle.factsheet;
  var bundleDescription = bundleFactsheet && (0,build_esm/* getFactsheetValueFromSlug */.l)(bundleFactsheet, 'apresentacao');
  var currentDescription = bundleDescription || description;
  productInfo.description = (options == null ? void 0 : options.getRawDescription) ? currentDescription : (0,build_esm/* cleanHtml */.ZF)(currentDescription);
  productInfo.factsheet = bundleFactsheet || factsheet;
  return (0,esm_extends/* default */.Z)({}, product, productInfo, {
    bundleId: bundleId
  });
};
/* harmony default export */ var hooks_useProductInfo = (useProductInfo);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useQuestionInputValidation.js
var useQuestionInputValidation = function useQuestionInputValidation() {
  var chars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$maxChars = _ref.maxChars,
    maxChars = _ref$maxChars === void 0 ? 140 : _ref$maxChars,
    _ref$minWords = _ref.minWords,
    minWords = _ref$minWords === void 0 ? 2 : _ref$minWords;
  var charsSplitted = chars.split(' ');
  var colorError = 'text.error';
  var colorDefault = 'text.light';
  if (chars.length > 0 && !/^[A-zÀ-ÿ\d\n $?!,.;+-]*$/.test(chars)) {
    return {
      message: 'A pergunta possui caracteres não permitidos, use digítos, números e acentuação (!?$ ou ,.;+-)',
      textColor: colorError,
      valid: false
    };
  }
  if (charsSplitted.length >= minWords && chars.length <= maxChars) {
    return {
      message: "".concat(maxChars - chars.length, " caracteres restantes"),
      textColor: colorDefault,
      valid: true
    };
  }
  if (chars.length > 0 && charsSplitted.length < minWords) {
    return {
      message: "A pergunta deve ter ao menos 2 palavras",
      textColor: colorError,
      valid: false
    };
  }
  if (chars.length > maxChars) {
    return {
      message: "Voc\xEA atingiu o tamanho m\xE1ximo da pergunta",
      textColor: colorError,
      valid: false
    };
  }
  return {
    message: "M\xE1ximo de ".concat(maxChars, " caracteres"),
    textColor: colorDefault,
    valid: false
  };
};
/* harmony default export */ var hooks_useQuestionInputValidation = (useQuestionInputValidation);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useUserData.js
var useUserData = __webpack_require__(16666);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useChatUserData.js



function useChatUserData_regeneratorRuntime() { "use strict"; useChatUserData_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


var useChatUserData = function useChatUserData(_ref) {
  var structure = _ref.structure;
  var _useState = (0,react.useState)(null),
    _useState2 = (0,slicedToArray/* default */.Z)(_useState, 2),
    data = _useState2[0],
    setData = _useState2[1];
  var _useState3 = (0,react.useState)(true),
    _useState4 = (0,slicedToArray/* default */.Z)(_useState3, 2),
    loading = _useState4[0],
    setLoading = _useState4[1];
  (0,react.useEffect)(function () {
    var getUserData = function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)(useChatUserData_regeneratorRuntime().mark(function _callee() {
        var response;
        return useChatUserData_regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              setLoading(true);
              _context.next = 4;
              return (0,useUserData/* default */.Z)({
                structure: structure
              });
            case 4:
              response = _context.sent;
              setData(response);
            case 6:
              _context.prev = 6;
              setLoading(false);
              return _context.finish(6);
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0,, 6, 9]]);
      }));
      return function getUserData() {
        return _ref2.apply(this, arguments);
      };
    }();
    getUserData();
  }, []);
  return {
    data: data,
    loading: loading
  };
};
/* harmony default export */ var hooks_useChatUserData = (useChatUserData);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useSelectedServices.js



var useSelectedServices = function useSelectedServices(defaultId) {
  var defaultIds = defaultId !== null ? [defaultId] : [];
  var _useState = useState(defaultIds),
    _useState2 = _slicedToArray(_useState, 2),
    selectedServicesIds = _useState2[0],
    setSelectedServicesIds = _useState2[1];
  var onSelectedServicesIdsChanged = useCallback(function (changedId, checked) {
    setSelectedServicesIds(function (prevState) {
      return checked ? [].concat(_toConsumableArray(prevState), [changedId]) : prevState.filter(function (id) {
        return id !== changedId;
      });
    });
  }, [setSelectedServicesIds]);
  return {
    onSelectedServicesIdsChanged: onSelectedServicesIdsChanged,
    selectedServicesIds: selectedServicesIds
  };
};
/* harmony default export */ var hooks_useSelectedServices = ((/* unused pure expression or super */ null && (useSelectedServices)));
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useServicesSelectedOffer.js




var getRecommendedOfferId = function getRecommendedOfferId(offers) {
  return (offers.find(function (offer) {
    return offer.recommended;
  }) || offers[0]).id;
};
var useServicesSelectedOffer = function useServicesSelectedOffer() {
  var services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var defaultServicesSelectedOfferId = services.reduce(function (acc, curr) {
    var _curr$offers;
    return _extends({}, acc, _defineProperty({}, curr.id, ((_curr$offers = curr.offers) == null ? void 0 : _curr$offers.length) > 0 ? getRecommendedOfferId(curr.offers) : null));
  }, {});
  var _useState = useState(defaultServicesSelectedOfferId),
    _useState2 = _slicedToArray(_useState, 2),
    servicesSelectedOfferId = _useState2[0],
    setServicesSelectedOfferId = _useState2[1];
  var onServicesSelectedOfferChange = useCallback(function (serviceId, offerId) {
    setServicesSelectedOfferId(function (prevState) {
      return _extends({}, prevState, _defineProperty({}, serviceId, offerId));
    });
  }, [setServicesSelectedOfferId]);
  return useMemo(function () {
    return {
      onServicesSelectedOfferChange: onServicesSelectedOfferChange,
      servicesSelectedOfferId: servicesSelectedOfferId
    };
  }, [servicesSelectedOfferId, onServicesSelectedOfferChange]);
};
/* harmony default export */ var hooks_useServicesSelectedOffer = ((/* unused pure expression or super */ null && (useServicesSelectedOffer)));
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useReviewInputValidation.js
var useReviewInputValidation = function useReviewInputValidation() {
  var chars = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var score = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$maxChars = _ref.maxChars,
    maxChars = _ref$maxChars === void 0 ? 1000 : _ref$maxChars,
    _ref$minWords = _ref.minWords,
    minWords = _ref$minWords === void 0 ? 2 : _ref$minWords;
  var splittedWords = chars.split(' ').filter(function (word) {
    return word !== '';
  });
  var charsLength = chars.length;
  var colorError = 'text.error';
  var colorDefault = 'text.light';
  if (charsLength === 0 && score <= 3) {
    return {
      message: "Este campo precisa ser preenchido",
      textColor: colorError,
      valid: false
    };
  }
  if (charsLength > 0 && splittedWords.length < minWords) {
    return {
      message: "O coment\xE1rio deve ter ao menos 2 palavras",
      textColor: colorError,
      valid: false
    };
  }
  return {
    message: "".concat(maxChars - charsLength, " caracteres restantes"),
    textColor: colorDefault,
    valid: true
  };
};
/* harmony default export */ var hooks_useReviewInputValidation = (useReviewInputValidation);
// EXTERNAL MODULE: ../modules/build/esm/commons/product.js
var commons_product = __webpack_require__(73659);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/useLastViewingProducts.js



function useLastViewingProducts_regeneratorRuntime() { "use strict"; useLastViewingProducts_regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,esm_typeof/* default */.Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,esm_typeof/* default */.Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


var useLastViewingProducts = function () {
  var _ref = (0,asyncToGenerator/* default */.Z)(useLastViewingProducts_regeneratorRuntime().mark(function _callee(product) {
    var _useStorage, append, remove, get, save, _get, items, normalizedId, productWithNormalizedId, duplicatedEl;
    return useLastViewingProducts_regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _useStorage = (0,build_esm/* useStorage */.y$)('viewing-history'), append = _useStorage.append, remove = _useStorage.remove, get = _useStorage.get;
          save = function save(_ref2) {
            var id = _ref2.id,
              category = _ref2.category,
              subcategory = _ref2.subcategory,
              brand = _ref2.brand,
              title = _ref2.title;
            append({
              brand: brand,
              category: category,
              id: id,
              subcategory: subcategory,
              title: title
            });
          };
          if (!(build_esm/* whereAmI.onClient */.er.onClient && product)) {
            _context.next = 16;
            break;
          }
          items = ((_get = get()) == null ? void 0 : _get.items) || [];
          normalizedId = (0,commons_product/* parseEcommerceProductId */.Y)(product);
          productWithNormalizedId = (0,esm_extends/* default */.Z)({}, product, {
            id: normalizedId
          });
          duplicatedEl = items.find(function (item) {
            return item.id === normalizedId;
          });
          if (!duplicatedEl) {
            _context.next = 12;
            break;
          }
          _context.next = 10;
          return remove(duplicatedEl.id);
        case 10:
          _context.next = 15;
          break;
        case 12:
          if (!(items.length >= 10)) {
            _context.next = 15;
            break;
          }
          _context.next = 15;
          return remove(items[0].id);
        case 15:
          save(productWithNormalizedId);
        case 16:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function useLastViewingProducts(_x) {
    return _ref.apply(this, arguments);
  };
}();
/* harmony default export */ var hooks_useLastViewingProducts = (useLastViewingProducts);
// EXTERNAL MODULE: ../modules/build/esm/hooks/useValidationCookie.js
var useValidationCookie = __webpack_require__(85978);
;// CONCATENATED MODULE: ../modules/build/esm/hooks/index.js













/***/ }),

/***/ 13450:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

var useDidUpdateEffect = function useDidUpdateEffect(fn, observer) {
  var didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (didMountRef.current) {
      fn();
    }
    didMountRef.current = true;
  }, observer);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDidUpdateEffect);

/***/ }),

/***/ 81692:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useHlsVideo; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95602);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var hls_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69818);



var DEFAULT_PROGRESS_CHECKPOINTS = [25, 50, 75];
var useHlsVideo = function useHlsVideo(_ref) {
  var videoUrl = _ref.videoUrl,
    _ref$isMuted = _ref.isMuted,
    initialIsMuted = _ref$isMuted === void 0 ? true : _ref$isMuted,
    _ref$progressCheckpoi = _ref.progressCheckpoints,
    progressCheckpoints = _ref$progressCheckpoi === void 0 ? DEFAULT_PROGRESS_CHECKPOINTS : _ref$progressCheckpoi,
    onStart = _ref.onStart,
    onComplete = _ref.onComplete,
    onProgress = _ref.onProgress,
    onError = _ref.onError;
  var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var hlsInstanceRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  var firedCheckpointsRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(new Set());
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialIsMuted),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_useState, 2),
    isMuted = _useState2[0],
    setIsMuted = _useState2[1];
  var getVideoInfo = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var video = videoRef.current;
    if (!video) {
      return {
        currentTime: 0,
        duration: 0,
        progressPercent: 0
      };
    }
    var currentTime = video.currentTime,
      duration = video.duration;
    var progressPercent = duration > 0 ? currentTime / duration * 100 : 0;
    return {
      currentTime: currentTime,
      duration: duration,
      progressPercent: progressPercent
    };
  }, []);
  var handleTimeUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function () {
    var video = videoRef.current;
    if (!video || video.duration === 0) {
      return;
    }
    if (!firedCheckpointsRef.current.has('start')) {
      firedCheckpointsRef.current.add('start');
      onStart == null ? void 0 : onStart(getVideoInfo());
    }
    var videoInfo = getVideoInfo();
    var progressPercent = videoInfo.progressPercent,
      currentTime = videoInfo.currentTime,
      duration = videoInfo.duration;
    if (onProgress) {
      progressCheckpoints.forEach(function (checkpoint) {
        if (progressPercent >= checkpoint && !firedCheckpointsRef.current.has(checkpoint)) {
          firedCheckpointsRef.current.add(checkpoint);
          onProgress(videoInfo);
        }
      });
    }
    var completeThresholdInSeconds = 0.5;
    if (onComplete && duration - currentTime <= completeThresholdInSeconds && !firedCheckpointsRef.current.has('complete')) {
      firedCheckpointsRef.current.add('complete');
      onComplete(videoInfo);
    }
  }, [getVideoInfo, onStart, onProgress, onComplete, progressCheckpoints]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    var videoElement = videoRef.current;
    if (!videoUrl || !videoElement) {
      return;
    }
    firedCheckpointsRef.current.clear();
    videoElement.addEventListener('timeupdate', handleTimeUpdate);
    if (hls_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].isSupported */ .ZP.isSupported()) {
      var hls = new hls_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP({
        capLevelToPlayerSize: true,
        startLevel: -1
      });
      hlsInstanceRef.current = hls;
      hls.loadSource(videoUrl);
      hls.attachMedia(videoElement);
      hls.on(hls_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Events.ERROR */ .ZP.Events.ERROR, function (_, data) {
        onError == null ? void 0 : onError(data);
      });
    } else if (videoElement.canPlayType('application/vnd.apple.mpegurl')) {
      videoElement.src = videoUrl;
    }
    return function () {
      videoElement.removeEventListener('timeupdate', handleTimeUpdate);
      if (hlsInstanceRef.current) {
        hlsInstanceRef.current.destroy();
      }
    };
  }, [videoUrl, handleTimeUpdate, onError]);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (videoRef.current) {
      videoRef.current.muted = isMuted;
    }
  }, [isMuted]);
  var controls = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function () {
    return {
      pause: function pause() {
        var _videoRef$current;
        return (_videoRef$current = videoRef.current) == null ? void 0 : _videoRef$current.pause();
      },
      play: function play() {
        var _videoRef$current2;
        return (_videoRef$current2 = videoRef.current) == null ? void 0 : _videoRef$current2.play()["catch"](function (err) {
          onError == null ? void 0 : onError(err);
        });
      },
      toggleMute: function toggleMute() {
        return setIsMuted(function (prev) {
          return !prev;
        });
      }
    };
  }, [onError]);
  return {
    controls: controls,
    isMuted: isMuted,
    videoRef: videoRef
  };
};

/***/ }),

/***/ 15138:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34795);
/* harmony import */ var _babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95602);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70314);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);



function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }


var useShortenLink = function useShortenLink(url, postData) {
  var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;
  var _publicRuntimeConfig$ = publicRuntimeConfig == null ? void 0 : publicRuntimeConfig.parceiromagalu,
    rochelle = _publicRuntimeConfig$.rochelle;
  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
    _useState2 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState, 2),
    shortLink = _useState2[0],
    setShortLink = _useState2[1];
  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
    _useState4 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState3, 2),
    isLoading = _useState4[0],
    setIsLoading = _useState4[1];
  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
    _useState6 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState5, 2),
    hasError = _useState6[0],
    setHasError = _useState6[1];
  var _useState7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({}),
    _useState8 = (0,_babel_runtime_helpers_esm_slicedToArray__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_useState7, 2),
    error = _useState8[0],
    setError = _useState8[1];
  var requestOptions = {
    body: JSON.stringify(postData),
    credentials: 'include',
    headers: {
      Accept: 'application/json',
      Cache: 'no-cache',
      'Content-Type': 'application/json'
    },
    method: 'POST'
  };
  var handleShortenLink = function () {
    var _ref = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee() {
      var response, err, data;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsLoading(true);
            setHasError(false);
            _context.prev = 2;
            _context.next = 5;
            return fetch(rochelle[url], requestOptions);
          case 5:
            response = _context.sent;
            if (response.ok) {
              _context.next = 10;
              break;
            }
            err = new Error("Rochelle request failed for ".concat(rochelle[url], " with status: ").concat(response.status, " ").concat(response.statusText));
            err.status = response.status;
            throw err;
          case 10:
            _context.next = 12;
            return response.json();
          case 12:
            data = _context.sent;
            setShortLink(data == null ? void 0 : data.shortenedLink);
            setIsLoading(false);
            return _context.abrupt("return");
          case 18:
            _context.prev = 18;
            _context.t0 = _context["catch"](2);
            setIsLoading(false);
            setHasError(true);
            setError(_context.t0);
            console.error("[useShortenLink] - err: ".concat(_context.t0));
          case 24:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 18]]);
    }));
    return function handleShortenLink() {
      return _ref.apply(this, arguments);
    };
  }();
  return {
    error: error,
    handleShortenLink: handleShortenLink,
    hasError: hasError,
    isLoading: isLoading,
    shortLink: shortLink
  };
};
/* harmony default export */ __webpack_exports__["Z"] = (useShortenLink);

/***/ }),

/***/ 16666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86522);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34795);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);


function _regeneratorRuntime() { "use strict"; _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == (0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError((0,_babel_runtime_helpers_esm_typeof__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }

var useUserData = function () {
  var _ref2 = (0,_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_regeneratorRuntime().mark(function _callee(_ref) {
    var _ref$structure, structure, _structure$config, config, logger, _structure$cookies, accountData, email, cookieId, name, customerId, id, userInfos, isLogged;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$structure = _ref.structure, structure = _ref$structure === void 0 ? {} : _ref$structure;
          _structure$config = structure.config, config = _structure$config === void 0 ? {} : _structure$config;
          logger = (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .Logger */ .Yd)(config);
          _context.prev = 3;
          accountData = ((_structure$cookies = structure.cookies) == null ? void 0 : _structure$cookies.accountData) || {};
          email = accountData.email, cookieId = accountData.id, name = accountData.name;
          customerId = accountData.customer_id;
          id = customerId || cookieId;
          if (!(!(config == null ? void 0 : config.isMiniApp) && (id || name || email))) {
            _context.next = 11;
            break;
          }
          logger.debug("[useUserData] - returning from cookies of structure", JSON.stringify({
            email: email,
            id: id,
            name: name
          }, null, 4));
          return _context.abrupt("return", {
            email: email,
            id: id,
            isLogged: Boolean(id && (name || email)),
            name: name
          });
        case 11:
          if (config == null ? void 0 : config.isMiniApp) {
            _context.next = 13;
            break;
          }
          return _context.abrupt("return", {
            email: undefined,
            isLogged: false,
            name: undefined
          });
        case 13:
          _context.next = 15;
          return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .useUserInfo */ .Pc)(logger);
        case 15:
          userInfos = _context.sent;
          _context.next = 18;
          return (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .useCheckUserCredentials */ .tI)();
        case 18:
          isLogged = _context.sent;
          logger.debug("[useUserData] - isLogged", isLogged);
          logger.debug("[useUserData] - returning from sdk", JSON.stringify(userInfos, null, 4));
          return _context.abrupt("return", {
            email: userInfos == null ? void 0 : userInfos.email,
            id: userInfos == null ? void 0 : userInfos.customer_id,
            isLogged: isLogged,
            name: userInfos == null ? void 0 : userInfos.name
          });
        case 24:
          _context.prev = 24;
          _context.t0 = _context["catch"](3);
          logger.error('[useUserData] - getting logged data', _context.t0);
          return _context.abrupt("return", {});
        case 28:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 24]]);
  }));
  return function useUserData(_x) {
    return _ref2.apply(this, arguments);
  };
}();
/* harmony default export */ __webpack_exports__["Z"] = (useUserData);

/***/ }),

/***/ 85978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
/* harmony import */ var _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62624);


var useValidationCookie = function useValidationCookie(cartId, cookieDomain) {
  var ML2_SID = _magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .cookiesConstants.ML2_SID */ .VD.ML2_SID;
  var isCartIdInvalid = cartId === null || cartId === 'null';
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
    if (isCartIdInvalid) {
      (0,_magalu_mixer_utils__WEBPACK_IMPORTED_MODULE_1__/* .removeCookie */ .nJ)(ML2_SID, cookieDomain, '/');
    }
  }, [cartId, cookieDomain]);
};
/* harmony default export */ __webpack_exports__["Z"] = (useValidationCookie);

/***/ }),

/***/ 54965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AccountCardList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AccountCardList; },
/* harmony export */   "AccountTitle": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AccountTitle; },
/* harmony export */   "ActionCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ActionCard; },
/* harmony export */   "AdsBanner": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AdsBanner; },
/* harmony export */   "AdsBrand": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AdsBrand; },
/* harmony export */   "AdsCarousel": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AdsCarousel; },
/* harmony export */   "AdsContext": function() { return /* reexport safe */ _contexts__WEBPACK_IMPORTED_MODULE_6__.$; },
/* harmony export */   "AdsShowcase": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AdsShowcase; },
/* harmony export */   "AlertText": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AlertText; },
/* harmony export */   "AllIn": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.AllIn; },
/* harmony export */   "AllInNewsletter": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.AllInNewsletter; },
/* harmony export */   "ApssFlyerBanner": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.ApssFlyerBanner; },
/* harmony export */   "AttributeList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.AttributeList; },
/* harmony export */   "Azion": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Azion; },
/* harmony export */   "BackToTop": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BackToTop; },
/* harmony export */   "BannerLink": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BannerLink; },
/* harmony export */   "BenefitsCardDesktop": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BenefitsCardDesktop; },
/* harmony export */   "BenefitsCardMobile": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BenefitsCardMobile; },
/* harmony export */   "BenefitsModal": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BenefitsModal; },
/* harmony export */   "BestInstallment": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BestInstallment; },
/* harmony export */   "Bing": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Bing; },
/* harmony export */   "BlogBreadCrumb": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogBreadCrumb; },
/* harmony export */   "BlogEcommerceLink": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogEcommerceLink; },
/* harmony export */   "BlogFooter": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogFooter; },
/* harmony export */   "BlogHeader": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogHeader; },
/* harmony export */   "BlogHeaderDesk": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogHeaderDesk; },
/* harmony export */   "BlogLinkList": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogLinkList; },
/* harmony export */   "BlogPagination": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogPagination; },
/* harmony export */   "BlogPostMetaData": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogPostMetaData; },
/* harmony export */   "BlogPostsList": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogPostsList; },
/* harmony export */   "BlogRecommendation": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogRecommendation; },
/* harmony export */   "BlogShareActions": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogShareActions; },
/* harmony export */   "BlogSubLinksRelated": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogSubLinksRelated; },
/* harmony export */   "BlogTagList": function() { return /* reexport safe */ _components_blog__WEBPACK_IMPORTED_MODULE_3__.BlogTagList; },
/* harmony export */   "BrandList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BrandList; },
/* harmony export */   "Breadcrumb": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Breadcrumb; },
/* harmony export */   "BuyBox": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BuyBox; },
/* harmony export */   "BuyButtonServices": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BuyButtonServices; },
/* harmony export */   "BuyButtons": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.BuyButtons; },
/* harmony export */   "CardanCarInformation": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CardanCarInformation; },
/* harmony export */   "CardanForm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CardanForm; },
/* harmony export */   "Carousel": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Carousel; },
/* harmony export */   "CarouselBanners": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CarouselBanners; },
/* harmony export */   "CategoryList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CategoryList; },
/* harmony export */   "ChatInbox": function() { return /* reexport safe */ _components_chat__WEBPACK_IMPORTED_MODULE_4__.ChatInbox; },
/* harmony export */   "ChatMessageChain": function() { return /* reexport safe */ _components_chat__WEBPACK_IMPORTED_MODULE_4__.ChatMessageChain; },
/* harmony export */   "ChatProductMessages": function() { return /* reexport safe */ _components_chat__WEBPACK_IMPORTED_MODULE_4__.ChatProductMessages; },
/* harmony export */   "ChatbotLu": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ChatbotLu; },
/* harmony export */   "Chip": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Chip; },
/* harmony export */   "CloseableAdUnit": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CloseableAdUnit; },
/* harmony export */   "Complaint": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Complaint; },
/* harmony export */   "ConfirmDialog": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ConfirmDialog; },
/* harmony export */   "ConfirmationReporting": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ConfirmationReporting; },
/* harmony export */   "CookieSecurity": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.CookieSecurity; },
/* harmony export */   "Criteo": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Criteo; },
/* harmony export */   "CustomPagination": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.CustomPagination; },
/* harmony export */   "Datadog": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Datadog; },
/* harmony export */   "DeliveryGuarantee": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.DeliveryGuarantee; },
/* harmony export */   "DeprecatedFinancialServices": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.DeprecatedFinancialServices; },
/* harmony export */   "DidYouMean": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.DidYouMean; },
/* harmony export */   "DocumentSupportText": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.DocumentSupportText; },
/* harmony export */   "Ebit": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Ebit; },
/* harmony export */   "EmptyReviewButton": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.EmptyReviewButton; },
/* harmony export */   "ExternalContent": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ExternalContent; },
/* harmony export */   "Factsheet": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Factsheet; },
/* harmony export */   "Faq": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Faq; },
/* harmony export */   "FastFilters": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FastFilters; },
/* harmony export */   "Favicon": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Favicon; },
/* harmony export */   "FilterDelivery": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FilterDelivery; },
/* harmony export */   "FinancialServices": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FinancialServices; },
/* harmony export */   "FinancialServicesNewLayout": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FinancialServicesNewLayout; },
/* harmony export */   "FinancialServicesSeparateSale": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FinancialServicesSeparateSale; },
/* harmony export */   "FloatText": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FloatText; },
/* harmony export */   "Footer": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Footer; },
/* harmony export */   "FooterDesktop": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FooterDesktop; },
/* harmony export */   "FooterDesktopPMD": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FooterDesktopPMD; },
/* harmony export */   "FooterService": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.FooterService; },
/* harmony export */   "FundingChoices": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.FundingChoices; },
/* harmony export */   "Gatekeeper": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Gatekeeper; },
/* harmony export */   "GenericButton": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.GenericButton; },
/* harmony export */   "GoogleTagManagerHead": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.GoogleTagManagerHead; },
/* harmony export */   "GoogleTagManagerNoscript": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.GoogleTagManagerNoscript; },
/* harmony export */   "Grid": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Grid; },
/* harmony export */   "Header": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Header; },
/* harmony export */   "HeaderDesktop": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HeaderDesktop; },
/* harmony export */   "HeaderDesktopPMD": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HeaderDesktopPMD; },
/* harmony export */   "HeaderPME": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HeaderPME; },
/* harmony export */   "Heading": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Heading; },
/* harmony export */   "HeadingProduct": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HeadingProduct; },
/* harmony export */   "HeadingSeller": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HeadingSeller; },
/* harmony export */   "HotLinks": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.HotLinks; },
/* harmony export */   "Hotjar": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Hotjar; },
/* harmony export */   "Image": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Image; },
/* harmony export */   "ImportTaxes": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ImportTaxes; },
/* harmony export */   "JsonLd": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.JsonLd; },
/* harmony export */   "Kwai": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Kwai; },
/* harmony export */   "LetMeKnow": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.LetMeKnow; },
/* harmony export */   "Link": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Link; },
/* harmony export */   "LinkList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.LinkList; },
/* harmony export */   "List": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.List; },
/* harmony export */   "Loader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Loader; },
/* harmony export */   "LoginMenuPMD": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.LoginMenuPMD; },
/* harmony export */   "LoyaltyCommission": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.LoyaltyCommission; },
/* harmony export */   "LuContent": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.LuContent; },
/* harmony export */   "MagaluAdsShowcase": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MagaluAdsShowcase; },
/* harmony export */   "MediaGallery": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MediaGallery; },
/* harmony export */   "MediaGalleryModal": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MediaGalleryModal; },
/* harmony export */   "MessageBox": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MessageBox; },
/* harmony export */   "MetaNoIndex": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MetaNoIndex; },
/* harmony export */   "MinimumOrderQuantity": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.MinimumOrderQuantity; },
/* harmony export */   "Newsletter": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Newsletter; },
/* harmony export */   "OfferTimer": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.OfferTimer; },
/* harmony export */   "OrderEligibleList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.OrderEligibleList; },
/* harmony export */   "Outdoor": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Outdoor; },
/* harmony export */   "Pagination": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Pagination; },
/* harmony export */   "Panel": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Panel; },
/* harmony export */   "PaymentMethods": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.PaymentMethods; },
/* harmony export */   "PercycleProductCarousel": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.PercycleProductCarousel; },
/* harmony export */   "PopularDepartments": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.PopularDepartments; },
/* harmony export */   "Preconnect": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Preconnect; },
/* harmony export */   "Preload": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Preload; },
/* harmony export */   "Product": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Product; },
/* harmony export */   "ProductBundleSelector": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductBundleSelector; },
/* harmony export */   "ProductCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductCard; },
/* harmony export */   "ProductCarouselSeller": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductCarouselSeller; },
/* harmony export */   "ProductCoupon": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductCoupon; },
/* harmony export */   "ProductDetail": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductDetail; },
/* harmony export */   "ProductInfoBar": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductInfoBar; },
/* harmony export */   "ProductList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductList; },
/* harmony export */   "ProductListSeller": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductListSeller; },
/* harmony export */   "ProductPrice": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductPrice; },
/* harmony export */   "ProductQAHighlights": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductQAHighlights; },
/* harmony export */   "ProductReviewForm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductReviewForm; },
/* harmony export */   "ProductReviewInfo": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductReviewInfo; },
/* harmony export */   "ProductReviewInfoBasic": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductReviewInfoBasic; },
/* harmony export */   "ProductReviewMediaCarousel": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductReviewMediaCarousel; },
/* harmony export */   "ProductRichContent": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ProductRichContent; },
/* harmony export */   "PromoterHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.PromoterHeader; },
/* harmony export */   "QuestionConfirm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuestionConfirm; },
/* harmony export */   "QuestionFeedback": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuestionFeedback; },
/* harmony export */   "QuestionFloatForm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuestionFloatForm; },
/* harmony export */   "QuestionForm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuestionForm; },
/* harmony export */   "QuestionList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuestionList; },
/* harmony export */   "QuickClickCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuickClickCard; },
/* harmony export */   "QuickClickShowcase": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.QuickClickShowcase; },
/* harmony export */   "RTBHouse": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.RTBHouse; },
/* harmony export */   "Radware": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Radware; },
/* harmony export */   "Rating": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Rating; },
/* harmony export */   "RatingLineGroup": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.RatingLineGroup; },
/* harmony export */   "RatingPlusScore": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.RatingPlusScore; },
/* harmony export */   "ReclameAqui": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.ReclameAqui; },
/* harmony export */   "ReportProduct": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReportProduct; },
/* harmony export */   "ReviewDimensions": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewDimensions; },
/* harmony export */   "ReviewForm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewForm; },
/* harmony export */   "ReviewHeaderMobile": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewHeaderMobile; },
/* harmony export */   "ReviewListHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewListHeader; },
/* harmony export */   "ReviewListing": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewListing; },
/* harmony export */   "ReviewModal": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewModal; },
/* harmony export */   "ReviewPaginationButton": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewPaginationButton; },
/* harmony export */   "ReviewPdpSection": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewPdpSection; },
/* harmony export */   "ReviewResult": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewResult; },
/* harmony export */   "ReviewSelectedFilter": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewSelectedFilter; },
/* harmony export */   "ReviewSummary": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewSummary; },
/* harmony export */   "ReviewTermsModal": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewTermsModal; },
/* harmony export */   "ReviewTotalizers": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ReviewTotalizers; },
/* harmony export */   "RichDescription": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.RichDescription; },
/* harmony export */   "Row": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Row; },
/* harmony export */   "SearchFilters": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchFilters; },
/* harmony export */   "SearchHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchHeader; },
/* harmony export */   "SearchOrder": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchOrder; },
/* harmony export */   "SearchRecommendation": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchRecommendation; },
/* harmony export */   "SearchResultsHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchResultsHeader; },
/* harmony export */   "SearchTitle": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SearchTitle; },
/* harmony export */   "SelectByRating": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SelectByRating; },
/* harmony export */   "SelectedFilters": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SelectedFilters; },
/* harmony export */   "SelectionCouponCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SelectionCouponCard; },
/* harmony export */   "SellerChatAndFollowButtons": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerChatAndFollowButtons; },
/* harmony export */   "SellerDelivery": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerDelivery; },
/* harmony export */   "SellerDetails": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerDetails; },
/* harmony export */   "SellerPageBanner": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerPageBanner; },
/* harmony export */   "SellerPageHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerPageHeader; },
/* harmony export */   "SellerStamp": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerStamp; },
/* harmony export */   "SellerStoreInfo": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SellerStoreInfo; },
/* harmony export */   "SeoCategoryTreeLinks": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SeoCategoryTreeLinks; },
/* harmony export */   "SeoLinkList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SeoLinkList; },
/* harmony export */   "SeoRelatedLinkList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SeoRelatedLinkList; },
/* harmony export */   "SeoSubcategoryList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SeoSubcategoryList; },
/* harmony export */   "ServicesActionButtons": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesActionButtons; },
/* harmony export */   "ServicesAuthorizationTerm": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesAuthorizationTerm; },
/* harmony export */   "ServicesCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesCard; },
/* harmony export */   "ServicesGroup": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesGroup; },
/* harmony export */   "ServicesInfo": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesInfo; },
/* harmony export */   "ServicesOfferPriceAndInstallments": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesOfferPriceAndInstallments; },
/* harmony export */   "ServicesProductCard": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesProductCard; },
/* harmony export */   "ServicesWrapper": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ServicesWrapper; },
/* harmony export */   "ShareActions": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ShareActions; },
/* harmony export */   "ShareLinks": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ShareLinks; },
/* harmony export */   "Shipping": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Shipping; },
/* harmony export */   "ShortenWidget": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ShortenWidget; },
/* harmony export */   "Showcase": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.Showcase; },
/* harmony export */   "SimpleHeader": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SimpleHeader; },
/* harmony export */   "SimpleHeaderPMD": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SimpleHeaderPMD; },
/* harmony export */   "SocialShare": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SocialShare; },
/* harmony export */   "SpotifyAdAnalytics": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.SpotifyAdAnalytics; },
/* harmony export */   "Stewie": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Stewie; },
/* harmony export */   "SubCategoryList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SubCategoryList; },
/* harmony export */   "SummaryTechnicalSheet": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SummaryTechnicalSheet; },
/* harmony export */   "SupportText": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.SupportText; },
/* harmony export */   "TabBuyBox": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TabBuyBox; },
/* harmony export */   "TabFactsheet": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TabFactsheet; },
/* harmony export */   "TabPaymentMethods": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TabPaymentMethods; },
/* harmony export */   "TabProductDetail": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TabProductDetail; },
/* harmony export */   "TabRating": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TabRating; },
/* harmony export */   "TermList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TermList; },
/* harmony export */   "TextList": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.TextList; },
/* harmony export */   "TikTok": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.TikTok; },
/* harmony export */   "ToolBar": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ToolBar; },
/* harmony export */   "VisibilitySection": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.VisibilitySection; },
/* harmony export */   "Vwo": function() { return /* reexport safe */ _novisual__WEBPACK_IMPORTED_MODULE_1__.Vwo; },
/* harmony export */   "WhatsAppFloatButton": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.WhatsAppFloatButton; },
/* harmony export */   "WishlistButton": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.WishlistButton; },
/* harmony export */   "ZipCodeBar": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ZipCodeBar; },
/* harmony export */   "ZipCodeInput": function() { return /* reexport safe */ _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__.ZipCodeInput; },
/* harmony export */   "inventory": function() { return /* binding */ inventory; },
/* harmony export */   "useAdsProvider": function() { return /* reexport safe */ _contexts__WEBPACK_IMPORTED_MODULE_6__.J; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85942);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(99616);
/* harmony import */ var _novisual__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37030);
/* harmony import */ var _components_blog__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(58035);
/* harmony import */ var _components_chat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23740);
/* harmony import */ var _components_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39509);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43812);



var ecommerce = _components__WEBPACK_IMPORTED_MODULE_0__/* .ecommerce */ .kl,
  blog = _components__WEBPACK_IMPORTED_MODULE_0__/* .blog */ .tQ,
  chat = _components__WEBPACK_IMPORTED_MODULE_0__/* .chat */ .W6;
var componentsBlogInventory = Object.keys(blog).reduce(function (acc, key) {
  return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(acc), [{
    name: key,
    ssr: blog[key].ssr,
    type: 'components/blog'
  }]);
}, []);
var componentsChatInventory = Object.keys(chat).reduce(function (acc, key) {
  return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(acc), [{
    name: key,
    ssr: chat[key].ssr,
    type: 'components/chat'
  }]);
}, []);
var componentsEcommerceInventory = Object.keys(ecommerce).reduce(function (acc, key) {
  return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(acc), [{
    name: key,
    ssr: ecommerce[key].ssr,
    type: 'components/ecommerce'
  }]);
}, []);
var novisualInventory = Object.keys(_novisual__WEBPACK_IMPORTED_MODULE_1__).reduce(function (acc, key) {
  return [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(acc), [{
    name: key,
    ssr: _novisual__WEBPACK_IMPORTED_MODULE_1__[key].ssr,
    type: 'novisual'
  }]);
}, []);
var inventory = [].concat((0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(componentsBlogInventory), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(componentsChatInventory), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(componentsEcommerceInventory), (0,_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(novisualInventory));






/***/ })

}]);